import Vue from 'vue';
import helper from './helper';
import mapsFun from './maps';

/** 注册全局过滤器 */

Vue.filter('pick', (value, def) => {
    if (!value) {
        return def;
    }
    return value;
});
Vue.filter('date', (value) => {
    return helper.date(value);
});

Vue.filter('dateMinuteTrend', (value) => {
    return helper.dateMinuteTrend(value);
});

Vue.filter('price', (value, fixValue) => {
    if (!value) {
        if (fixValue) return fixValue;
        return 0;
    }
    return (value / 100) || 0;
});

Vue.filter('dateMinute', (value, flagFilterMinute) => {
    if (!value) { return ''; }
    return helper.dateMinute(value, flagFilterMinute);
});

Vue.filter('map', (value, key) => {
    if (!value && value !== 0) { return ''; }
    return mapsFun(key, value);
});

Vue.filter('fromatNum', (value) => {
    if (!value) { return 0; }
    return helper.fromatNumber(value);
});

Vue.filter('secondToMinute', (value) => {
    if (!value) { return '0'; }
    return helper.secondsToMinutes(value);
});

Vue.filter('cutstring', (value) => {
    if (!value) { return ''; }
    return helper.cutstring(value);
});
Vue.filter('cutStrings', (value) => {
    if (!value) { return ''; }
    return helper.cutStrings(value);
});

Vue.filter('minutesToHoursWithMinutes', (value) => {
    if (value === null || value === undefined) {
        value = 0;
    }
    return helper.minutesToHoursWithMinutes(value);
});

Vue.filter('cleanSpelChar', (value) => {
    if (!value) { return ''; }
    return helper.cleanSpelChar(value);
});
